<template>
  <div v-if="showCard" class="dioptra-overlay" @click="closeModal">
    <div class="dioptra-modal-product-card" v-if="productData" :style="showCard ? 'display:grid' : 'display:none'" @click.stop>
      <div class="dioptra-modal-product-card-close">
          <span class="closeQuickModalText" v-on:click="closeModal">
            Κλείσιμο
          </span>
        </div>
      <div class="dioptra-modal-content">
        <div class="dioptra-modal-product-card-image">
          <adv-html-picture
            v-if="mainImage && mainImage.original_raw"
            :srcset-image="mainImage.original_raw"
            srcset-profile="from_w600"
            :width="270"
            :height="420"
            img-class="img-fluid"
            :loading="'eager'"
            :alt="`${productCodeId}`"
          />
          <div v-if="isCustomerLoggedIn" class="product-card-actions-row">
            <div v-if="productInCustomerFavourites" class="prod-card-action">
              <button
                type="button"
                id="wishlistAction"
                class="wishlist_action add-to-wishlist"
                data-action="remove"
                data-view_form="list_item"
                :data-product_id="productId"
                @click="onAddToWishlistAction"
              >
                <img src="/ui/main/img/heart_full_icon.svg" width="29" height="25" :alt="`Remove ${productId} from wishlist`">
              </button>
            </div>
            <div v-else class="prod-card-action">
              <button
                type="button"
                id="wishlistAction"
                class="wishlist_action add-to-wishlist"
                data-action="add"
                data-view_form="list_item"
                :data-product_id="productId"
                @click="onAddToWishlistAction"
              >
                <img src="/ui/main/img/add_to_wishlist.svg" alt="Add to wishlist" loading="lazy" width="29" height="25">
              </button>
            </div>
          </div>
          <div v-else class="product-card-actions-row">
            <div class="prod-card-action">
              <button type="button" class="add-to-wishlist launch-login" @click="onAddToWishlistAction">
                <img src="/ui/main/img/add_to_wishlist.svg" alt="Add to wishlist" loading="lazy" width="29" height="25">
              </button>
            </div>
          </div>
        </div>
        <div class="dioptra-modal-product-card-content">
          <div class="dioptra-modal-product-card-header">
            <div v-if="productData.authors && productData.authors.length > 0" class="dioptra-modal-product-card-authors">
              {{productData.authors[0]}}
            </div>
            <div class="dioptra-modal-product-card-name">
              {{productData.productName}}
            </div>
          </div>
          <div class="dioptra-modal-product-card-body">
            <div class="dioptra-modal-product-card-body-books">
              <div v-if="bookVariation" class="dioptra-modal-product-card-book">
                <AdvProductPageCard
                  class="dioptra-product-page-card-container"
                  :product-id="Number(bookVariation.productId)"
                  :show-signature="false"
                  :product-meta-data="bookProductMetaData"
                  @add-to-cart="closeModal"
                >
                  <template v-slot:prices>
                    <div v-if="bookVariation?.metaData?.freeEbook !== '1'" class="dioptra-product-tab-actions-buy">
                      <div class="dioptra-product-tab-actions-buy-prices">
                        <div class="dioptra-product-tab-actions-buy-prices-discount-container">
                            <span v-if="bookVariation?.metaData?.freeEbook !== '1'" class="dioptra-product-tab-book-price-title">Τιμή Βιβλίου</span>
                            <span v-if="bookVariation.productDisclosure && !getProductChartSettings.enabled" class="dioptra-product-tab-actions-buy-prices-discount">
                                <span>{{ bookVariation.productDisclosure }}</span>
                            </span>
                          <span v-else-if="getProductChartSettings.enabled && bookVariation.priceTracking.shouldDisplay && bookVariation.priceTracking.discountPass" class="dioptra-product-tab-actions-buy-prices-discount">
                              {{ Number(bookVariation.priceTracking.saveValue * getSelectedCurrency.rate).toFixed(2) }}
                              <span v-html="getSelectedCurrency.symbol"></span>
                            </span>
                        </div>
                        <div class="dioptra-product-tab-actions-buy-prices-container">
                            <span v-if="getProductDiscountValue(bookVariation) > 0 && !getProductChartSettings.enabled" class="dioptra-product-tab-actions-buy-prices-starting">
                              {{ Number(bookVariation.productOldPrice * getSelectedCurrency.rate).toFixed(2) }}
                              <span v-html="getSelectedCurrency.symbol"></span>
                            </span>
                          <span v-else-if="getProductChartSettings.enabled && bookVariation.priceTracking.shouldDisplay && bookVariation.priceTracking.discountPass" class="dioptra-product-tab-actions-buy-prices-starting">
                              {{ Number(bookVariation.priceTracking.referencePrice * getSelectedCurrency.rate).toFixed(2) }}
                              <span v-html="getSelectedCurrency.symbol"></span>
                            </span>
                          <span v-if="bookVariation?.metaData?.freeEbook !== '1'" class="dioptra-product-tab-actions-buy-prices-final">
                              <meta itemprop="priceCurrency" content="EUR"/>
                              <span itemprop="price" class="dioptra-product-tab-actions-buy-prices-final-price">
                                {{ Number(bookVariation.productFinalPrice * getSelectedCurrency.rate).toFixed(2) }}
                                <span v-html="getSelectedCurrency.symbol"></span>
                              </span>
                            </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </AdvProductPageCard>
                <div v-if="eBookVariation?.metaData?.freeEbook !== '1' && bookVariation?.metaData?.freeEbook !== '1'" class="dioptra-modal-product-card-extra-info">
                  <span class="dioptra-modal-product-card-extra-info-text">Δωρεάν μεταφορικά άνω των 20€</span>
                </div>
              </div>
              <div v-if="eBookVariation" class="dioptra-modal-product-card-book">
                <AdvProductPageCard
                  v-if="eBookVariation"
                  class="dioptra-product-page-card-container"
                  :product-id="Number(eBookVariation.productId)"
                  :is-digital="true"
                  :epub-apple-link="eBookVariation.epubAppleLink"
                  :show-signature="false"
                  :product-meta-data="eBookProductMetaData"
                  @add-to-cart="closeModal"
                >
                  <template v-slot:prices>
                    <div v-if="eBookVariation?.metaData?.freeEbook !== '1'" class="dioptra-product-tab-actions-buy">
                      <div class="dioptra-product-tab-actions-buy-prices">
                        <div class="dioptra-product-tab-actions-buy-prices-discount-container">
                            <span v-if="eBookVariation?.metaData?.freeEbook !== '1'" class="dioptra-product-tab-book-price-title">Τιμή Ebook</span>
                            <span v-if="eBookVariation.productDisclosure && !getProductChartSettings.enabled" class="dioptra-product-tab-actions-buy-prices-discount">
                                <span>{{ eBookVariation.productDisclosure }}</span>
                            </span>
                          <span v-else-if="getProductChartSettings.enabled && eBookVariation.priceTracking.shouldDisplay && eBookVariation.priceTracking.discountPass" class="dioptra-product-tab-actions-buy-prices-discount">
                              {{ Number(eBookVariation.priceTracking.saveValue * getSelectedCurrency.rate).toFixed(2) }}
                              <span v-html="getSelectedCurrency.symbol"></span>
                            </span>
                        </div>
                        <div class="dioptra-product-tab-actions-buy-prices-container">
                            <span v-if="getProductDiscountValue(eBookVariation) > 0 && !getProductChartSettings.enabled" class="dioptra-product-tab-actions-buy-prices-starting">
                              {{ Number(eBookVariation.productOldPrice * getSelectedCurrency.rate).toFixed(2) }}
                              <span v-html="getSelectedCurrency.symbol"></span>
                            </span>
                          <span v-else-if="getProductChartSettings.enabled && eBookVariation.priceTracking.shouldDisplay && eBookVariation.priceTracking.discountPass" class="dioptra-product-tab-actions-buy-prices-starting">
                              {{ Number(eBookVariation.priceTracking.referencePrice * getSelectedCurrency.rate).toFixed(2) }}
                              <span v-html="getSelectedCurrency.symbol"></span>
                            </span>
                          <span v-if="eBookVariation?.metaData?.freeEbook !== '1'" class="dioptra-product-tab-actions-buy-prices-final">
                              <meta itemprop="priceCurrency" content="EUR"/>
                              <span itemprop="price" class="dioptra-product-tab-actions-buy-prices-final-price">
                                {{ Number(eBookVariation.productFinalPrice * getSelectedCurrency.rate).toFixed(2) }}
                                <span v-html="getSelectedCurrency.symbol"></span>
                              </span>
                            </span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="dioptra-product-tab-free-ebook">
                      <span>Το ebook δίνεται <strong>Δωρεάν</strong>!</span>
                    </div>
                  </template>
                </AdvProductPageCard>
              </div>
            </div>

            <div class="dioptra-modal-product-card-body-info">
              <div class="dioptra-product-tab-details-content-container">
                <div class="dioptra-product-tab-details-content">
                  <span class="dioptra-product-tab-details-content-title">Προστασία DRM:</span>
                  <span class="dioptra-product-tab-details-content-description">Ναι</span>
                </div>
                <div class="dioptra-product-tab-details-content">
                  <span class="dioptra-product-tab-details-content-title">ebook format:</span>
                  <span class="dioptra-product-tab-details-content-description">ePub</span>
                </div>
                <div class="dioptra-product-tab-details-content">
                  <span class="dioptra-product-tab-details-content-title">Συμβατότητα:</span>
                  <span class="dioptra-product-tab-details-content-description">iOS, Android, Windows</span>
                </div>
              </div>
              <div class="dioptra-product-tab-actions-instructions-container">
                <a class="dioptra-product-tab-actions-instructions" href="/category/voitheia-gia-ta-ebooks" target="_blank">
                    <span class="dioptra-product-tab-actions-instructions-text">
                      <span class="info-lottie">
                        <Lottie
                          ref="lottie"
                          :animation-data="lottieFile"
                          :auto-play="true"
                          :loop="true"
                          width="20px"
                          height="20px"
                        />
                    </span>
                    <span class="modal-instructions-text">Δες οδηγίες εγκατάστασης των ebooks</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, get, isEmpty, some } from 'lodash-es'
import store from '../../vue/store'
import productMixin from '../../design/vue/mixins/productMixins'
import { mapActions, mapGetters } from 'vuex'
import AdvHtmlPicture from '../../vue/components/AdvHtmlPicture.vue'
import AdvProductPageCard from './AdvProductPageCard.vue'
import Lottie from './Lottie.vue'
import infoLottie from '../lotties/product_page_info_icon.json'
import cartButtonMixin from './mixins/cartButtonMixin'

export default {
  name: 'DioptraModalProductCard',
  components: {
    AdvHtmlPicture,
    AdvProductPageCard,
    Lottie
  },
  props: {
    productId: {
      type: Number
    },
    recommendationType: {
      type: String,
      default: null
    },
    recommendationId: {
      type: String,
      default: null
    },
    isCustomerLoggedIn: {
      type: Boolean,
      default: false
    },
    customerFavouriteIds: {
      type: Array,
      default: () => []
    }
  },
  mixins: [productMixin, cartButtonMixin],
  data () {
    return {
      version: '0.0.2',
      productCodeId: null,
      quantity: 1,
      showCard: true,
      progress: false,
      mainImage: {
        is_main: '1',
        original: store.state.noImage,
        small: store.state.noImage,
        medium: store.state.noImage,
        large: store.state.noImage
      },
      productVariations: [],
      bodyOverflowHidden: false
    }
  },
  mounted () {
    this.setProductCodeIdForOneOnOne()
    this.setMainImage()
    this.setProductVariations()
    this.toggleBodyOverflow()
  },
  beforeDestroy () {
    this.toggleBodyOverflow()
  },
  watch: {
    productId () {
      this.setProductCodeIdForOneOnOne()
      this.setMainImage()
    }
  },
  computed: {
    ...mapGetters([
      'getUniqueProductVariationValueIds',
      'cartProductWithCustomizationQuantity',
      'cartProductCodeQuantity',
      'getSelectedCurrency'
    ]),
    ...mapGetters('cartProductCustomizations', ['getSchemaById']),
    ...mapGetters('productChart', ['getProductChartSettings']),
    config () {
      return store.getters.config
    },
    hasAttributes () {
      return some(this.productData.productCodes, (e) => {
        return e.productCodeAttributes.length > 0
      })
    },
    getCustomizationSchema () {
      if (!('customizationSchemaId' in this.productData) || this.productData.customizationSchemaId === null) {
        return null
      }
      if (('customizationSchemaRange' in this.productData) && this.productData.customizationSchemaRange !== null) {
        const from = this.productData.customizationSchemaRange.from
        const to = this.productData.customizationSchemaRange.to
        if (from !== null && new Date(from) > new Date()) {
          return null
        }
        if (to !== null && new Date(to) < new Date()) {
          return null
        }
      }
      const schema = this.getSchemaById(this.productData.customizationSchemaId)
      if (!schema || !('schema' in schema) || ('is_active' in schema && schema.is_active === false)) {
        return null
      }
      return cloneDeep(schema)
    },
    hasVariationEntries () {
      return this.getUniqueProductVariationValueIds.length > 0
    },
    listImage () {
      return this.productData ? this.productData.productImage.list : store.getters.noImage
    },
    inactiveProduct () {
      return !this.productCodeData.productActive
    },
    unavailableProduct () {
      const firstEditionDate = this.productData?.metaData?.firstEditionDate ? new Date(this.productData?.metaData?.firstEditionDate) : null
      if (firstEditionDate && firstEditionDate > new Date()) {
        return false
      }
      return this.productCodeData.productStock <= 0 || this.productData.productFinalPrice <= 0
    },
    cartLimitForProductReached () {
      const firstEditionDate = this.productData?.metaData?.firstEditionDate ? new Date(this.productData?.metaData?.firstEditionDate) : null
      if (firstEditionDate && firstEditionDate > new Date()) {
        return false
      }
      return (Number(this.productCodeData.productStock) + Number(this.productCodeData.productPendingStock)) === Number(this.cartQuantity)
    },
    selectedAttributeId () {
      return parseFloat(store.getters.getSelectedAttributeId)
    },
    cartQuantity () {
      if (
        this.getCustomizationSchema !== null &&
        !isEmpty(get(this, ['$refs', 'customizationEditor', 'getSchema']))
      ) {
        return this.cartProductWithCustomizationQuantity(
          this.productCodeId,
          this.$refs.customizationEditor?.getSchema,
          0
        )
      }
      return this.cartProductCodeQuantity(this.productCodeId, 0)
    },
    maxAmountForInputSpinner () {
      return this.productCodeData.productStock - this.cartQuantity
    },
    variationsActive () {
      return store.getters.getVariationsActive
    },
    bookVariation () {
      const bookVariation = this.productVariations.find(variation => variation.isDigital === false)
      if (bookVariation) {
        return bookVariation
      }
      return null
    },
    eBookVariation () {
      const digitalVariation = this.productVariations.find(variation => variation.isDigital === true)
      if (digitalVariation) {
        return digitalVariation
      }
      return null
    },
    lottieFile () {
      return infoLottie
    },
    productInCustomerFavourites () {
      return this.customerFavouriteIds.map(Number).includes(this.productId)
    },
    bookProductMetaData () {
      return this.bookVariation?.metaData || this.productData?.metaData || null
    },
    eBookProductMetaData () {
      return this.eBookVariation?.metaData || this.productData?.metaData || null
    }
  },
  methods: {
    ...mapActions(['addToCartClicked', 'setSelectedProductCodeId', 'setSelectedAttributeId']),
    setProductCodeIdForOneOnOne () {
      if (!this.hasAttributes) {
        this.codeIdChanged(this.productData.productCodes[0].productCodeId)
        return
      }

      this.quantity = 1
    },
    toggleBodyOverflow () {
      this.bodyOverflowHidden = !this.bodyOverflowHidden
      document.body.style.overflow = this.bodyOverflowHidden ? 'hidden' : 'auto'
    },
    closeModal () {
      this.showCard = false
      this.$emit('close-quick-view')
      this.clearSelectedAttributeId()
    },
    clearSelectedAttributeId () {
      if (this.hasAttributes) {
        this.setSelectedAttributeId(null)
      }
    },
    priceWithSign (priceString, priceSign) {
      return (parseFloat(priceString) * this.getSelectedCurrency.rate).toFixed(2) + priceSign
    },
    getSign () {
      return this.getSelectedCurrency.symbol
    },
    diffStringPrices (priceA, priceB) {
      return (parseFloat(priceA) - parseFloat(priceB)).toFixed(2).toString()
    },
    attributeSelected (attributeId) {
      this.setSelectedAttributeId(attributeId)
    },
    codeIdChanged (productCodeId) {
      this.productCodeId = productCodeId
      if (this.productCodeId) {
        this.setSelectedProductCodeId(this.productCodeId)
        this.setMainImage()
      }
    },
    setMainImage () {
      if (this.productCodeId) {
        this.mainImage = this.productData.images[this.productCodeId].find(image => image.is_main === '1')
      } else {
        this.mainImage = this.productData.images[parseInt(Object.keys(this.productData.images)[0])].find(image => image.is_main === '1')
      }
    },
    getProductDiscountValue (product) {
      return product.productOldPrice - product.productFinalPrice
    },
    setProductVariations () {
      const variations = []
      if (!this.productData.variations) {
        return variations
      }
      this.productData.variations.forEach((variation) => {
        const productVariation = store.getters.getProductById(variation)
        if (productVariation) {
          variations.push(productVariation)
        }
      })
      variations.push(this.productData)
      this.productVariations = variations
    },
    onAddToWishlistAction () {
      if (!this.isCustomerLoggedIn) {
        document.dispatchEvent(new CustomEvent('launchLogin'))
        this.closeModal()
        return
      }

      document.dispatchEvent(new CustomEvent('addToWishlist', {
        detail: document.getElementById('wishlistAction')
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
.dioptra-modal-content {
  position: relative;
  display:flex;
  flex-wrap:wrap;
  padding-bottom: 1rem;
  @media screen and (max-width:575px){
    align-content:flex-start
  }
}
.dioptra-modal-product-card {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  width: auto;
  max-width: 900px;
  left: 0;
  right: 0;
  margin: 0 auto;
  // padding: 10px 15px 15px;
  padding:0 15px;
  z-index: 9000;
  background: #fff;
  max-height: 80%;
  overflow-y: auto;
  .dioptra-product-page-card-container{
    padding-left:0;
    padding-right:0;
    align-items: first baseline
  }
  @media screen and (min-width:768px) and (max-width:991px){
    max-width:85%
  }
  @media screen and (max-width: 767px) {
    width: 90%;
    margin: 0 auto;
    top: 50%;
    transform:translateY(-50%);
    height: fit-content;
    max-height:80vh;
    overflow-y: auto;
    padding: 0 10px;
  }
  &-header {
    display: flex;
    flex-wrap: wrap;
    width:100%
  }
  &-body {
    width: 100%;
    display: flex;
    flex-wrap:wrap;
    &-books {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      gap: 50px;
      @media screen and (max-width:1199px){
        gap:25px;
      }
      @media screen and (max-width: 767px) {
        gap:10px;
      }
    }
    &-info {
      display: grid;
      width: 100%;
    }
  }
  &-footer {
    display: grid;
    grid-template-columns: 2fr  1fr;
    grid-template-rows: auto auto;
    padding-top: 1rem;
    @media screen and (max-width: 767px) {
      grid-template-columns: 1fr;
    }
  }
}
.dioptra-modal-product-card-price {
  grid-column: 2;
  position: relative;
  display: grid;
  gap: 1rem;
  grid-template-columns: auto auto;
  align-items: end;
  justify-content: end;
  @media screen and (max-width: 767px) {
    grid-column: 1;
    align-items: center;
    justify-content: center;
  }
}

.dioptra-modal-product-card-image {
  position: relative;
  display:flex;
  flex-wrap:wrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  height: max-content;
  @media screen and (min-width:576px) and (max-width:767px){
    flex:0 0 50%;
    max-width:50%;
    padding: 50px;
    position: relative;
    background-color: #F2F5F5C4;
  }

  @media screen and (min-width:768px){
    flex:0 0 50%;
    max-width:50%;
    padding: 50px 75px;
    position: relative;
    background-color: #F2F5F5C4;
  }
  @media screen and (max-width:575px){
    flex:0 0 100%;
    max-width: 100%;
    padding: 50px 75px 5px 75px;
  }
}

.dioptra-modal-product-card-name {
  color: var(--prime1);
  font-size: 25px;
  font-weight: 700;
  width: 100%;
  min-height: 90px;
  @media screen and (min-width:576px) and (max-width:991px){
    min-height:50px
  }
  @media screen and (max-width: 575px) {
    font-size: 17px;
    grid-row: 2;
    min-height: 44px;
    padding-bottom: 0;
    text-align:center;
    font-weight: 400;
  }
}
.dioptra-modal-product-card-price-final {
  font-size: 32px;
  font-weight: 600;
  color: var(--prime1);
  @media screen and (max-width: 767px) {
    font-size: 26px;
  }
  @media screen and (max-width:575px){
    font-size: 30px;
  }
  @media screen and (max-width:425px){
    font-size: 24px;
  }
}
.dioptra-modal-product-card-price-og {
  color: #878888;
  font-size: 16px;
  font-weight: 600;
  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
}
.adv-button-view-buy-picker {
  grid-row: 1 / span 2;
  grid-column: 2;
  @media screen and (max-width: 767px) {
    grid-column: 1;
    grid-row: 2;
  }
}
::v-deep .quick-v-attr-select {
  gap: 1rem;
  @media screen and (max-width: 767px) {
    grid-template-columns: 1fr;
  }
}
.dioptra-modal-product-card-close {
  display: grid;
  width: 100%;
  justify-content: end;
  @media screen and (max-width:767px){
    position:absolute;
    top:10px;
    right:10px;
    z-index:2
  }
}
.closeQuickModalText {
  display: grid;
  color: #231F20;
  text-align: end;
  font-size: 15px;
  cursor: pointer;
  width: fit-content;
  @media screen and (min-width:768px){
    padding:20px 0 0 0
  }
  // padding-top:10px
}
.dioptra-modal-product-card-authors {
  color: #D2232A;
  font-size: 18px;
  font-weight: 500;
  min-height: 50px;
  flex:0 0 100%;
  max-width:100%;
  @media screen and (max-width:575px){
    text-align: center;
    min-height:40px;
    font-size: 16px;
  }
}
.dioptra-product-tab-actions-buy-prices-final {
  line-height: 1;
  display: block;
  text-align: end;
  // &.desktop {
  //   margin-left:auto;
  // }
  &.mobile {
    padding-bottom: 0;
    @media screen and (min-width: 1200px) {
      display: none;
    }
  }
}
.dioptra-product-tab-details {
  position: relative;
  width: 100%;
  @media screen and (max-width:1199px){
    display: none;
  }
}
.dioptra-product-tab-actions {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.dioptra-product-tab-actions-buy-prices-container {
  display: flex;
  align-items: center;
  gap: 5px;
  width:100%;
  @media screen and (min-width:576px){
    justify-content: flex-start
  }
  @media screen and (max-width:575px){
    flex-wrap: wrap;
    flex:0 0 50%;
    max-width:50%;
    gap:0;
    justify-content:flex-end
  }
}

.dioptra-product-tab-actions-buy-prices {
  display:flex;
  flex-wrap:wrap;
  width: 100%;
  align-items: center;
  gap: 5px;
  @media screen and (max-width:1199px) {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  @media screen and (max-width:767px){
    gap:0;
    padding-top: 10px;
    padding-bottom: 10px;
  }

}
.dioptra-product-tab-actions-buy-prices-discount {
  font-weight: 600;
  padding: 0 10px;
  flex: 0 0 auto;
  max-width: fit-content;
  font-size:15px;
  background-color: #a49cb4;
  color: #fff;
  @media screen and (max-width:575px) {
    padding: 0 5px;
  }
}

.dioptra-product-tab-actions-buy-prices-starting {
  color: #878C8D;
  font-size: 20px;
  text-decoration: line-through;
  line-height: 1;
  align-self:flex-end;
  padding-bottom:2px;
  padding-right:10px;
  @media screen and (min-width:768px) and (max-width:1199px){
    font-size:16px
  }
  @media screen and (max-width:767px){
    flex:0 0 auto;
    padding-right:5px;
    max-width:50%;
    padding-bottom:0
  }
  @media screen and (max-width:575px){
    font-size: 20px;
  }
  @media screen and (max-width:425px){
    font-size: 17px;
  }
}
.dioptra-product-tab-actions-buy-prices-final {
  color: #231F20;
  font-size: 30px;
  font-weight: 700;
  line-height: 1;
  @media screen and (min-width:768px) and (max-width:1199px){
    font-size:20px
  }
  @media screen and (max-width:767px){
    flex:0 0 auto;
    max-width:50%
  }
  @media screen and (max-width:400px){
    font-size:16px
  }
}
.dioptra-product-tab-actions-buy {
  display: flex;
  flex-wrap:wrap;
  width:100%;
  align-items: center;
  gap: 5px
}
::v-deep .quick-v-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: flex-end;
  gap:15px;
  @media screen and (min-width:768px) and (max-width:1199px){
    align-items: center
  }
  @media screen and (max-width:767px){
    display:flex;
    flex-wrap:wrap;
    width: 100%;
    align-items:center;
    gap:0;
    grid-template-columns:none
  }
  .quick-v-tocart{
    margin-top:12px;
    @media screen and (max-width:767px){
      width:100%!important;
    }
    @media screen and (max-width:575px){
      margin-top: 0;
    }
  }
  &:first-child{
    .dioptra-product-tab-actions-buy-prices-final.desktop{
      margin-left:auto
    }
  }
  .col-12.quick-v-unavailable{
    display:none
  }
  .quick-v-quantity{
    padding-left:0;
    padding-right:0;
    &.quick-v-unavailable{
      background:#F2F2F2;
      color:#989898;
      font-size:20px;
      padding:10px
    }
  }
}
.dioptra-product-tab-book-price-title {
  color: #231F20;
  font-size: 17px;
  @media screen and (max-width:1199px){
    font-size:14px
  }
  @media screen and (min-width:576px){
    flex: 0 0 auto;
    max-width: fit-content
  }
}
::v-deep .add-to-cart-btn-img {
  display: none;
}
.dioptra-product-tab-actions-buy-prices-discount-container {
  display: flex;
  align-items: center;
  gap: 25px;
  width:100%;
  @media screen and (min-width:576px) and (max-width:1199px){
    margin-bottom:10px
  }
  @media screen and (max-width:575px){
    flex-wrap:wrap;
    max-width:50%;
    gap: 10px;
  }
}
::v-deep .add-to-cart-btn {
  padding: 5px;
}
::v-deep .add-to-cart-btn[disabled]:before {
  background: transparent;
}
.dioptra-modal-product-card-extra-info {
  padding-top: 10px;
  @media screen and (max-width: 575px) {
    text-align: center;
    padding-top: 2px;
  }
}
.dioptra-modal-product-card-extra-info-text {
  color: #231F20;
  font-size: 12px;
  font-weight: 700;
  @media screen and (max-width:575px){
    text-align: center
  }
}
.dioptra-product-tab-actions-instructions-container {
  display: flex;
}

.dioptra-product-tab-actions-instructions {
  position: relative;
  display: flex;
  gap: 10px;
  padding: 10px;
  border: 1px solid #989898;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  width:100%;
  @media screen and (max-width: 1199px) {
    margin-bottom: 20px;
  }
  @media screen and (max-width:575px){
    width: 100%;
    margin-bottom: 10px;
    margin-top: 10px;
  }
}
.dioptra-product-tab-actions-instructions-text {
  color: #231F20;
  font-size: 12px;
  display:flex;
  flex-wrap:wrap;
  width:100%;
  align-items: center;
  justify-content: center
}

.info-lottie{
  flex:0 0 auto;
  max-width: 30px
}

.modal-instructions-text{
  flex:0 0 auto;
  padding-left:10px;
  max-width:calc(100% - 30px)
}

.dioptra-product-tab-details-content-container {
  display: flex;
  gap: 5px;
  flex-direction: column;
  padding-top: 12px;
  height: auto;
  min-height: fit-content;
  @media screen and (max-width:575px){
    align-items: center;
  }
}
.dioptra-product-tab-details-content {
  display: flex;
  align-items: center;
  gap: 3px;
}
.dioptra-product-tab-details-content-title {
  color: #989898;
  font-size: 12px;
}
.dioptra-product-tab-details-content-description {
  color: #231F20;
  font-size: 12px;
}
.dioptra-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(22 22 21 / 60%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 8999;
}
.dioptra-product-tab-actions-buy-prices-final-price {
  display: flex;
  align-items: center
}

.dioptra-modal-product-card-content{
  @media screen and (min-width:576px){
    flex:0 0 50%;
    max-width:50%;
    display:flex;
    flex-wrap:wrap;
    align-content: flex-start;
    align-items: flex-start;
    padding-left:15px
  }
  @media screen and (max-width:575px){
    position:relative;
  }
}

.dioptra-modal-product-card-book{
  width:100%;
  height:fit-content
}

.dioptra-modal-product-card-header{
  @media screen and (min-width:576px){
    padding-top:20px
  }
}

.add-to-wishlist {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

.product-card-actions-row {
  @media screen and (max-width:575px){
    right: unset;
    left: 0;
  }
}

.dioptra-product-tab-free-ebook {
  display: flex;
  text-align: center;
  padding-bottom: 15px;
  span {
    font-size: 1rem;
    color: #231F20;
    strong {
      color: #D2232A;
    }
  }
}
</style>
